module.exports = __webpack_public_path__ + "img/Banner_3.1d5ebdea.svg";